import { useEffect, useState } from 'react'

export const useOptimisticValue = <T>(
    actualValue: T,
    isEqual?: (a: T, b: T) => boolean
) => {
    const [optimisticValue, setOptimisticValue] = useState<T | null>(null)

    useEffect(() => {
        if (
            optimisticValue &&
            (isEqual
                ? isEqual(optimisticValue, actualValue)
                : optimisticValue === actualValue)
        ) {
            setOptimisticValue(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEqual, actualValue])

    return { value: optimisticValue ?? actualValue, setOptimisticValue }
}
